import React from "react";
import { useSelector } from "react-redux";

import {
  FormControl,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import classnames from "classnames";

import { DashboardMenuItem, MenuItemLink } from "react-admin";

import { useUser } from "../../authenticatorApp/UserContext";
import {
  HashIcon,
  InboundIcon,
  InventoryIcon,
  InvoicesIcon,
  LogoutIcon,
  OutboundIcon,
  ProductIcon,
  ProfileIcon,
  SitIcon,
  TrainIcon,
  // ReportsIcon,
  // TaskListIcon,
  UserIcon,
} from "../../components/common/iconography";
import { AclType } from "../../utils/constants";
import { truncateText } from "../../utils/utils";
import { SubMenu } from "../../components/SubMenu";
import { NewBadge } from "../../components/common/FeatureBadges";
import { hasTracks } from "../../utils/locationUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  open: {
    width: 210,
  },
  closed: {
    width: 55,
  },
  formControlOpen: {
    marginLeft: theme.spacing(2),
    height: theme.spacing(4),
    minWidth: 192,
  },
  formControlClosed: {
    display: "none",
  },
}));

export const CustomerMenu = ({ onMenuClick, dense }) => {
  const classes = useStyles();
  useSelector((state) => state.theme);
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const { appUser, isAuthorized, isMultiTenant } = useUser();

  const showTrackManagement = React.useMemo(() => {
    return hasTracks() && isAuthorized(AclType.TRACK_MANAGEMENT);
  }, [isAuthorized]);

  return (
    <div
      className={classnames(classes.root, {
        [classes.open]: open,
        [classes.closed]: !open,
      })}
    >
      {isMultiTenant() && (
        <FormControl
          className={classnames({
            [classes.formControlOpen]: open,
            [classes.formControlClosed]: !open,
          })}
        >
          <Typography variant="body1">
            {truncateText(appUser?.reloadYard?.name, 21)}
          </Typography>
        </FormControl>
      )}

      <DashboardMenuItem
        onClick={onMenuClick}
        sidebarIsOpen={open}
        primaryText="Dashboard"
      />
      <MenuItemLink
        to={`/inboundShipments`}
        primaryText="Inbound Shipments"
        leftIcon={<InboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {isAuthorized(AclType.SIT) && (
        <MenuItemLink
          to="/sitList"
          primaryText="SIT Cars"
          leftIcon={<SitIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      <MenuItemLink
        to={`/outboundShipments`}
        primaryText="Outbound Shipments"
        leftIcon={<OutboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {showTrackManagement && (
        <MenuItemLink
          to={`/trackManagement`}
          primaryText="Track Management"
          leftIcon={<TrainIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      <SubMenu
        // name="Inventory"
        name={
          <>
            Inventory
            <NewBadge />
          </>
        }
        icon={<InventoryIcon />}
        sidebarIsOpen={open}
        defaultTo="/inventories" // <-- click here will navigate
        onClick={onMenuClick} // <-- and close the menu
      >
        <MenuItemLink
          to="/inventories"
          primaryText="By Lot #"
          leftIcon={<HashIcon ml={1} />}
          onClick={onMenuClick}
        />
        <MenuItemLink
          to="/products"
          primaryText="By Product"
          leftIcon={<ProductIcon />}
          onClick={onMenuClick}
        />
      </SubMenu>
      {isAuthorized(AclType.INVOICES_VIEW) && (
        <MenuItemLink
          to={`/invoices`}
          primaryText="Invoices"
          leftIcon={<InvoicesIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isAuthorized(AclType.USERS) ? (
        <MenuItemLink
          to={`/customers`}
          primaryText="Users"
          leftIcon={<UserIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      ) : (
        <MenuItemLink
          to={`/customers/${appUser?.id}`}
          primaryText="Profile"
          leftIcon={<ProfileIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {/* <MenuItemLink
				to={`/tasks`}
				primaryText="Tasks"
				leftIcon={<TaskListIcon />}
				onClick={onMenuClick}
				sidebarIsOpen={open}
				dense={dense}
			/> */}
      {/* {
				!isXSmall &&
				<MenuItemLink
					to={`/reports`}
					primaryText="Reports"
					leftIcon={<ReportsIcon />}
					onClick={onMenuClick}
					sidebarIsOpen={open}
					dense={dense}
				/>
			} */}
      {isXSmall && (
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
          sidebarIsOpen={open}
        />
      )}
    </div>
  );
};
